import { render, staticRenderFns } from "./Map.vue?vue&type=template&id=21724730&scoped=true&"
import script from "./Map.vue?vue&type=script&lang=js&"
export * from "./Map.vue?vue&type=script&lang=js&"
import style0 from "./Map.vue?vue&type=style&index=0&id=21724730&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21724730",
  null
  
)

export default component.exports
import QDialog from 'quasar/src/components/dialog/QDialog.js';
import QCard from 'quasar/src/components/card/QCard.js';
import QBtn from 'quasar/src/components/btn/QBtn.js';
import QCardSection from 'quasar/src/components/card/QCardSection.js';
import qInstall from "../../../../node_modules/@quasar/app/lib/webpack/runtime.auto-import.js";
qInstall(component, 'components', {QDialog,QCard,QBtn,QCardSection});
